<template>
  <el-dialog class="store-dialog" width="900px" title="选择商品" :visible.sync="showDialog" :close-on-click-modal="false" :before-close="cancelAction" append-to-body>
    <!-- <el-tabs v-model="params.item_type" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="实体类商品" name="normal"></el-tab-pane>
      <el-tab-pane label="服务类商品" name="services"></el-tab-pane>
    </el-tabs> -->
    <div v-if="params.item_type === 'normal'" style="margin-bottom: 15px;">
      <StoreFilter v-if="!filter" class="store" :data="store" @change="handleStoreChange" />
      <el-row :gutter="10">
        <el-col :span="4">
          <div style="margin-top: 10px">
            <el-checkbox v-model="params.choose_all" label="选中全部" border @change="chooseAll"></el-checkbox>
          </div>
        </el-col >
        <el-col :span="6">
          <el-input placeholder="输入商品名称" v-model="params.keywords" clearable class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="searchByKey"></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="商品货号" v-model="params.item_bn" clearable class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="searchByKey"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-select v-model="params.approve_status" placeholder="选择状态" clearable @change="searchByKey">
            <el-option
              v-for="item in statusOption"
              :key="item.value"
              :label="item.title"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col >
        <el-col :span="4">
          <el-cascader
                  placeholder="选择标签"
                  filterable
                  :options="tag.list"
                  :props="{value:'tag_id', label: 'tag_name'}"
                  v-model='select_tags_value'
                  clearable
                  @change="searchByKey">
          </el-cascader>
        </el-col>
        <!--<el-col :span="4">-->
          <!--<el-select v-model="params.templates_id" @change="searchByKey" clearable placeholder="选择运费模板">-->
            <!--<el-option v-for="item in templatesList" :key="item.template_id" :label="item.name" :value="item.template_id"></el-option>-->
          <!--</el-select>-->
        <!--</el-col>-->
        <!--<el-col :span="8">-->
          <!--<el-input placeholder="0" v-model="store_value" class="input-with-select" clearable >-->
            <!--<el-select v-model="storeSelect" slot="prepend" placeholder="库存筛选" style="width: 110px">-->
              <!--<el-option label="库存大于" value="gt"></el-option>-->
              <!--<el-option label="库存小于" value="lt"></el-option>-->
            <!--</el-select>-->
            <!--<el-button slot="append" icon="el-icon-search" @click="storeChangeSelect"></el-button>-->
          <!--</el-input>-->
        <!--</el-col>-->
      </el-row>
    </div>
    <el-table ref="multipleTable" v-if="singleData" :data="itemsData" tooltip-effect="dark" style="width: 100%" v-loading="loading">
      <el-table-column label="选择" width="70">
        <template slot-scope="scope">
          <el-radio :label="scope.row.itemId" v-model="templateRadio"
                    @change.native="getTemplateRow(scope.$index,scope.row)">&nbsp;
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="itemId" label="商品ID" width="70"></el-table-column>
      <el-table-column prop="item_bn" label="货号" width="70">
        <template slot-scope="scope">
          {{scope.row.item_bn}}
        </template>
      </el-table-column>
      <el-table-column prop="itemName" label="商品名称"></el-table-column>
      <el-table-column prop="special_type" label="类型">
        <template slot-scope="scope">
          <span style="color:red"  v-if="scope.row.special_type == 'drug'" >处方药</span>
          <span style="color:blue" v-else>非处方药</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" width="80" :formatter="priceformatter" show-overflow-tooltip></el-table-column>
      <el-table-column prop="store" label="库存" width="80" show-overflow-tooltip></el-table-column>
    </el-table>
    <el-table ref="multipleTable" v-else :data="itemsData" tooltip-effect="dark" style="width: 100%" @select="handleSelectChange" @select-all="handleSelectAll" v-loading="loading" :row-key="getRowKeys" :select-on-indeterminate="false">
      <el-table-column type="selection" :selectable="disabledItem" :reserve-selection="true" width="50"></el-table-column>
      <el-table-column prop="itemId" label="商品ID" width="70"></el-table-column>
      <el-table-column prop="item_bn" label="货号" width="70">
        <template slot-scope="scope">
          {{scope.row.item_bn}}
        </template>
      </el-table-column>
      <el-table-column prop="itemName" label="商品名称"></el-table-column>
      <el-table-column prop="special_type" label="类型">
        <template slot-scope="scope">
          <span style="color:red"  v-if="scope.row.special_type == 'drug'" >处方药</span>
          <span style="color:blue" v-else>非处方药</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" width="80" :formatter="priceformatter" show-overflow-tooltip>

      </el-table-column>
      <el-table-column prop="store" label="库存" width="80" show-overflow-tooltip></el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="pager">
      <el-pagination
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="total_count" :page-size="params.pageSize">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelAction">取 消</el-button>
      <el-button type="primary" @click="saveStoreAction">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import StoreFilter from '@/components/function/storeFilter'
  import { getItemsList, getCategory,
      getTagList,
      itemsRelTags,
      tagSearchItem, } from '@/api/goods'
  import { getShippingTemplatesList } from '@/api/shipping'
  import { getDefaultCurrency } from '@/api/company'

  export default {
    props: {
      itemsVisible: {
        type: Boolean,
        default: false
      },
      getStatus: {
        type: Boolean,
        default: false
      },
      relStore: {
        type: Object,
        default: function() {
          return {}
        }
      },
      relItemsIds: {
        type: Array,
        default: []
      },
      hiddenData: {
        type: Array,
        default: function() {
          return []
        }
      },
      itemType: {
        type: String,
        default: ''
      },
      filter: [String, Object],
      notSku: {
        type: Boolean,
        default: false
      },
      isSpec: {
        type: Boolean,
        default: false
      },
      limitNum: {
        type: Number,
        default: 0
      },
      single: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        itemsData: [],
        multipleSelection: [],
        selectRows: [],
        total_count: '',
        activeType: 'first',
        store: {},
        tag: {
              dialog: false,
              editItem: [],
              list: [],
              form: {
                  tag_ids: [],
                  item_ids: []
              },
              currentTags: [],
              tags: []
       },
        select_tags_value:[],
        params: {
          page: 1,
          pageSize: 10,
          keywords: '',
          item_type: 'normal',
          // special_type: 'normal',
          approve_status: 'onsale',
          templates_id: '',
          distributor_id: '',
          is_sku: false,
          tag_id: '',
          choose_all:false,
        },
        hiddenItem: [],
        storeSelect: '',
        store_value: '',
        templatesList: [],
        statusOption: [
          {
            title: '前台可销售',
            value: 'onsale'
          },
          {
            title: '可线下销售',
            value: 'offline_sale'
          },
          {
            title: '前台仅展示',
            value: 'only_show'
          },
          {
            title: '不可销售',
            value: 'instock'
          }
        ],
        currency: {},
        cursymbol: '￥',
        templateRadio: ''
      }
    },
    components: {
      StoreFilter
    },
    methods: {
      chooseAll(val){
        if(val == true){
          this.$message({message: '请稍后...', type: 'warning'})
          this.params.pageSize = this.total_count
          getItemsList (this.params).then(response => {
            this.$message({message: '本次选中了'+this.total_count+'个商品', type: 'success'})
            var data = response.data.data.list
            this.selectRows = []
            this.selectRows= data
          })
        }else{
          this.selectRows = []
          this.$refs.multipleTable.clearSelection()
           this.$message({message: '本次清空了所有选中商品', type: 'success'})
            this.selectRows = []
        }
      },
      handleTabClick () {
        this.getNewsList()
      },
      handleStoreChange (val) {
        this.store = val
        this.selectRows = []
        this.$refs.multipleTable.clearSelection()
        this.params.distributor_id = val.id
        this.getNewsList()
      },
      getTemplateRow(index, row) {
        this.selectRows = new Array(row)
      },
      disabledItem(row, index) {
        if (this.hiddenItem.indexOf(row.itemId) > -1) {
          return false
        } else {
          return true
        }
      },
      getRowKeys (row) {
        return row.itemId
      },
      handleCurrentChange (page_num) {
        this.$refs.multipleTable.clearSelection()
        this.params.page = page_num
        this.getNewsList()
      },
      searchByKey () {
        if (this.select_tags_value) {
          this.params.tag_id = this.select_tags_value[0]
        }
        this.params.page = 1
        this.getNewsList()
      },
      getAllTagLists() {
            let params = {
                page: 1,
                pageSize: 500
            }
            getTagList(params).then(response => {
                this.tag.list = response.data.data.list
            })
      },
      storeChangeSelect() {
        if (this.storeSelect == 'gt') {
          this.params.store_gt = this.store_value
        }
        if (this.storeSelect == 'lt') {
          this.params.store_lt = this.store_value
        }
        this.params.page = 1
        this.getNewsList()
      },
      handleSelectAll (val) {
        if (this.limitNum) {
          this.$message({message: '当前组件不支持全选', type: 'warning'})
          this.$refs.multipleTable.clearSelection()
          this.itemsData.forEach(item => {
            let checked = this.selectRows.find(n => n.itemId === item.itemId)
            if (checked) {
              this.$refs.multipleTable.toggleRowSelection(item)
            }
          })
          return
        }
        if (val.length > 0) {
          val.forEach(item => {
            let inChecked = this.selectRows.findIndex(n => item.itemId === n.itemId)
            if (inChecked === -1) {
              this.selectRows.push(item)
            }
          })
        } else {
          this.itemsData.forEach((item, index) => {
            let inChecked = this.selectRows.findIndex(n => item.itemId === n.itemId)
            if (inChecked !== -1) {
              this.selectRows.splice(inChecked, 1)
            }
          })
        }
      },
      handleSelectChange (val, row) {
        let inChecked = this.selectRows.findIndex(item => row.itemId === item.itemId)
        if (inChecked !== -1) {
          this.selectRows.splice(inChecked, 1)
        } else {
          if (this.limitNum && this.limitNum == 1) {
            this.selectRows = []
            this.selectRows.push(row)
            this.$refs.multipleTable.clearSelection()
            this.selectRows.forEach(item => {
              this.$refs.multipleTable.toggleRowSelection(item)
            })
            return
          } else if (this.limitNum && this.selectRows.length >= this.limitNum) {
            this.$message({message: `最多选择${this.limitNum}件商品`, type: 'warning'})
            this.$refs.multipleTable.clearSelection()
            this.selectRows.forEach(item => {
              this.$refs.multipleTable.toggleRowSelection(item)
            })
            return
          }
          this.selectRows.push(row)
        }
      },
      cancelAction () {
        this.selectRows = []
        this.$emit('closeStoreDialog')
      },
      saveStoreAction () {
        this.$emit('chooseStore', this.selectRows, this.store)
      },
      getNewsList () {
        if (this.getStatus) {
          this.loading = true
          getItemsList (this.params).then(response => {
            this.itemsData = response.data.data.list
            this.total_count = parseInt(response.data.data.total_count)
            this.loading = false
          })
        }
      },
      getShippingTemplatesList () {
        this.loading = true
        getShippingTemplatesList(this.templatesParams).then(response => {
          this.templatesList = response.data.data.list
        })
      },
      getCurrencyInfo() {
        getDefaultCurrency().then(res => {
          this.currency = res.data.data
          this.cursymbol = this.currency.symbol
        })
      },
      getCategory() {
        getCategory([]).then(response => {
          this.categoryList = response.data.data
        })
      },
      priceformatter(row, column) {
         if( (row.only_show_price_low!='0')||(row.only_show_price_high!='0')){
             return this.cursymbol + row.only_show_price_low/100 + '-' + row.only_show_price_high/100;
             // return this.cursymbol + row.price / 100;
         }else{
             return this.cursymbol + row.price / 100;
         }

      },
      changeGoods (type) {
       switch (type) {
         case 'every':
           this.$set(this.params,'consume_type','every')
           this.$delete(this.params,'item_type')
           this.itemType = 'every'
           break
         case 'normal':
           this.$set(this.params,'item_type','normal')
           this.$delete(this.params,'consume_type')
           this.itemType = 'normal'
           break
       }
       this.getNewsList()
      }
    },
    mounted () {
      if (this.filter) {
        let filters = this.filter
        let params = this.params
        if (typeof(filters) === 'string') {
          filters = JSON.parse(filters)
        }
        Object.assign(params, filters)
        this.params = params
      }
      this.getShippingTemplatesList()
      this.getCurrencyInfo()
      this.getAllTagLists()
    },
    computed: {
      showDialog () {
        return this.itemsVisible
      },
      singleData(){
        return this.single
      }
    },
    watch: {
      itemsVisible (val) {
        if (val) {
          this.params.keywords = ''
          if (this.isSpec) {
            this.params.is_sku = this.isSpec
          }
          if (this.notSku) {
            Object.assign(this.params, {nospec: true})
          }
          let ids = []
          this.loading = true
          this.multipleSelection.forEach(item => {
            ids.push(item.item_id)
          })
          console.log(ids)
          if (ids.length > 0) {
            let param = JSON.parse(JSON.stringify(this.params))
            param.page = 1
            param.pageSize = 999
            param.item_id = ids
            this.selectRows = []
            getItemsList (param).then(res => {
              this.selectRows = res.data.data.list
              this.$refs.multipleTable.clearSelection()
              this.itemsData.forEach(item => {
                let checked = this.selectRows.find(n => n.itemId === item.itemId)
                if (checked) {
                  this.$refs.multipleTable.toggleRowSelection(item)
                }
              })
              this.loading = false
            })
          } else {
            const that = this
            this.$nextTick(() => {
              that.$refs.multipleTable.clearSelection()
            })
            this.loading = false
          }
        }
      },
      relItemsIds (newVal, oldVal) {
        if (newVal.length > 0) {
          this.multipleSelection = newVal
        }
      },
      relStore (newVal, oldVal) {
        if (newVal.id) {
          this.store = newVal
        }
      },
      itemsData (val) {
        if (this.selectRows.length > 0) {
          this.itemsData.forEach(item => {
            let checked = this.selectRows.find(n => n.itemId === item.itemId)
            if (checked) {
              this.$refs.multipleTable.toggleRowSelection(item)
            }
          })
        }
      },
      getStatus (newVal, oldVal) {
        if (newVal) {
          this.getNewsList()
        }
      },
      itemType (newVal, oldVal) {
        if (newVal) {
          this.params.item_type = newVal
        }
      },
      hiddenData(val) {
        this.hiddenItem = val
      },
      single(val) {
        this.singleData = val
      }
    }
  }
</script>

<style scoped lang="scss">
  .store {
    margin-bottom: 10px;
  }
  .store-dialog .el-checkbox {
    display: inline;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .el-select .el-input {
    width: 130px;
  }
  .pager {
    margin-top: 20px;
  }
  .tab-group {
    .tab-btn {
     &.on {
       border-color: #e6a23c;
       background-color: #e6a23c;
       color: #fff;
     }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?649ba237